export const Logo = ({ className = "w-9 h-9" }) => (
  <img src="/logo-round.png" alt="MF Logistics Consulting Group" className={`${className} rounded-full object-cover`} />
);

export const Wordmark = () => (
  <span className="flex items-center gap-3">
    <Logo className="w-10 h-10 shrink-0" />
    <span className="leading-none text-left">
      <span className="block text-[15px] tracking-[0.04em]" style={{ fontFamily: '"Playfair Display", serif', fontWeight: 700 }}>
        MF Logistics
      </span>
      <span className="mono block text-[9.5px] opacity-70 mt-1 uppercase">Consulting Group</span>
    </span>
  </span>
);
